import React from "react";
import { StyleSheet, View } from "react-native";
import color from "@constants/color";
import CustomText from "@components/CustomText";
import RadioButton from "@components/RadioButton";

const ReasonForNotDeliveredModal = ({
  currentFilter = {},
  setCurrentFilter = () => {},
  data = {},
}) => {
  const {
    title = "",
    warningTitle = "",
    warningMessage = "",
    reasons = [],
  } = data || {};

  const setSelectedOption = (key) => {
    if (currentFilter === key) return;
    setCurrentFilter(key);
  };

  return (
    <View style={styles.container}>
      <CustomText variant="title_16" newfont={true} style={styles.title}>
        {title}
      </CustomText>
      <View style={styles.infoContainer}>
        <CustomText
          variant="subtitle_16"
          newfont={true}
          style={styles.infoTitle}
        >
          {warningTitle}
        </CustomText>
        <CustomText
          variant="body_text_3"
          newfont={true}
          style={styles.infoDescription}
        >
          {warningMessage}
        </CustomText>
      </View>
      <RadioButton
        radioOptions={reasons}
        setSelectedOption={setSelectedOption}
        labelColor={color.mediumBlack}
        radioColor={color.primary}
        active={currentFilter.key}
        radionButtonContainerStyle={styles.radioButtonContainerStyle}
      />
    </View>
  );
};

export default ReasonForNotDeliveredModal;

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    marginTop: 8,
    paddingVertical: 20,
  },
  title: {
    color: color.mediumBlack,
    marginHorizontal: 16,
  },
  infoContainer: {
    backgroundColor: "#FFF5F2",
    borderWidth: 1,
    borderColor: "#FFCDC2",
    height: 110,
    borderRadius: 8,
    marginTop: 8,
    padding: 12,
    marginHorizontal: 16,
  },
  infoTitle: {
    color: color.plain_red,
  },
  infoDescription: {
    color: color.mediumBlack,
    marginTop: 4,
  },
  radioButtonContainerStyle: {
    marginTop: 16,
  },
});
